import {useLocation} from 'react-router';
import {getAuthContextState,subscribeAuthContextState} from './auth_context_store';
import {resolveSaasContext} from './saasContext';
import {createContext,useContext,useState,useSyncExternalStore,type ReactNode} from 'react';
import {createDashboardPageContext} from './dashboardPageContext';
import type {DashboardContext} from './dashboardContextBus';
export type LinkedScreenBus=ReturnType<typeof createDashboardPageContext>;
const LinkedScreenContext=createContext<LinkedScreenBus|null>(null);
/** Embed native blocks in a host dashboard while keeping its page-scoped context bus. */
export function LinkedScreenBusProvider({bus,children}:{bus:LinkedScreenBus;children:ReactNode}) {
 return <LinkedScreenContext.Provider value={bus}>{children}</LinkedScreenContext.Provider>;
}
/** Mounted by the module session: no global cache, storage or broadcast of record values. */
export function LinkedScreenContextProvider({children}:{children:ReactNode}) {
 const [bus]=useState(()=>createDashboardPageContext());
 return <LinkedScreenContext.Provider value={bus}>{children}</LinkedScreenContext.Provider>;
}
export function useLinkedScreenContext(initial:DashboardContext):LinkedScreenBus {
 const shared=useContext(LinkedScreenContext);
 const [local]=useState(()=>createDashboardPageContext(initial));
 return shared??local;
}

/** Scope resets on identity, workspace, portal, year or module change; navigation inside a module retains selections. */
export function LinkedScreenSession({children}:{children:ReactNode}) {
 const location=useLocation(),auth=useSyncExternalStore(subscribeAuthContextState,getAuthContextState,getAuthContextState);
 const segments=location.pathname.split('/').filter(Boolean),scope=segments.slice(0,/^\d{4}$/.test(segments[2]??'')?4:3);
 const key=JSON.stringify([resolveSaasContext().tenantId,auth?.userId,...scope]);
 return <LinkedScreenContextProvider key={key}>{children}</LinkedScreenContextProvider>;
}
